export default __webpack_public_path__ + "6453351c4de1692752ae29db417829d5.png";